import React from 'react';

import Header from '../../layout/Header.jsx';
import ListPerformance from '../../lists/ListPerformance.jsx';

const PagePerformance = () => (
  <div>
    <Header>Performance</Header>
    <ListPerformance />
  </div>
);

export default PagePerformance;
